import React, { useEffect } from 'react';
import { Container } from '@exxonmobil/react-unity';
import ServiceFlow from './components/ServiceFlow';
import DataTable from './components/DataTable';
import PageTitle from '../common/components/PageTitle';
import { useDomainsApi, useServiceMapsApi } from './hooks/useApi';

const domainTableHeaders = [
  { title: 'Name' },
  { title: 'Current status' },
  {
    title: 'Availability (YTD)',
    description:
      'Average availability excluding planned maintenance (4 hours a month) of all services for specified domain from year to date.'
  },
  {
    title: 'Event Usage (YTD)',
    description: 'The total number of Kafka messaging usages for all services for specified domain from year to date.'
  },
  {
    title: 'API Usage (YTD)',
    description: 'The total number of API usage of all services for specified domain from year to date.'
  }
];

export const Dashboard = () => {
  const { data: domains, error: domainsError, isLoading: domainsIsLoading, fetch: fetchDomains } = useDomainsApi();
  const { data: serviceMaps, error: serviceFlowError, fetch: fetchServiceMaps } = useServiceMapsApi();
  useEffect(() => {
    const timer = setInterval(() => {
      fetchDomains();
      fetchServiceMaps();
    }, 600000);
    return () => clearInterval(timer);
  }, [fetchDomains, fetchServiceMaps]);

  return (
    <>
      <PageTitle title="System Status" />
      <Container>
        <ServiceFlow serviceMaps={serviceMaps ?? []} isError={!!serviceFlowError} onRefresh={fetchServiceMaps} />
        <DataTable
          domains={domains ?? []}
          isLoading={domainsIsLoading}
          isError={!!domainsError}
          domainTableHeaders={domainTableHeaders}
          onRefresh={fetchDomains}
        />
      </Container>
    </>
  );
};
